export default __webpack_public_path__ + "static/media/3_Gift@3x.3b4780cb.png";